module.exports = __webpack_public_path__ + "static/media/checklist.3a1e9b09.png";